import InvestmentProfileCardSendFunding from "./InvestmentProfileCardSendFunding"

export default InvestmentProfileCardSendFunding
